import Vue from 'vue';
import VueRouter from 'vue-router';
//懒加载模式
const Main = () => import('../views/main.vue');
const Login = () => import('../views/index/login.vue');//登录页面
const index = () => import('../views/index/index.vue');//首页
const AuthList = () => import('../views/auth/AuthList.vue');//权限列表
const AddAuth = () => import('../views/auth/AddAuth.vue');//添加权限
const EditAuthName = () => import('../views/auth/EditAuthName.vue');//编辑顶级权限名称
const AddZjAuth = () => import('../views/auth/AddZjAuth.vue');//添加子级权限
const roleList = () => import('../views/role/roleList.vue');//角色列表
const addRole = () => import('../views/role/addRole.vue');//添加角色
const adminUser = () => import('../views/adminUser/adminUser.vue');//后台用户列表
const AddAdminUser = () => import('../views/adminUser/AddAdminUser.vue');//添加后台用户
const userList = () => import('../views/user/userList.vue');//用户列表
const userInfo = () => import('../views/user/userInfo.vue');//用户详情
const comList = () => import('../views/company/comList.vue');//公司列表
const auditCom = () => import('../views/company/auditCom.vue');//公司审核
const newList = () => import('../views/company/newList.vue');//公告列表
const auditNew = () => import('../views/company/auditNew.vue');//公告审核
const articleList = () => import('../views/article/articleList.vue');//文章列表
const sunArticle = () => import('../views/article/sunArticle.vue');//二级文章列表
const version = () => import('../views/app/version.vue');//APP版本列表
const devList = () => import('../views/device/list.vue');//设备列表
const devDetail = () => import('../views/device/devDetail.vue');//设备详情
const labelList = () => import('../views/label/list.vue');//标签列表
const userLabel = () => import('../views/user/userLabel');//用户标签
const wxExport = () => import('../views/device/wxExport');//维修单导出
const gzExport = () => import('../views/device/gzExport');//故障率导出
const djtype = () => import('../views/djg/type');//刀具柜分类管理
const djglist = () => import('../views/djg/djglist');//刀具柜列表
const djgyy = () => import('../views/djg/djgyy');//刀具柜运营
const djgbpk = () => import('../views/djg/djgbpk');//标品库
const djgsp = () => import('../views/djg/djgsp');//标品库审批
const djgGoods = () => import('../views/djg/djgGoods');//刀具柜商品列表
const djggg = () => import('../views/djg/djggg');//刀具柜广告
const djghd = () => import('../views/djg/djghd');//刀具柜货道
const djgorder = () => import('../views/djg/djgorder');//刀具柜订单管理
const djgjb = () => import('../views/djg/djgjb');//刀具柜警报
const djgrz = () => import('../views/djg/djgrz/djgrz');//刀具柜日志
const djgver = () => import('../views/djg/djgver/djgver');//刀具柜版本管理
const djgls = () => import('../views/djg/djgls/djgls');//刀具柜历史记录
const fpdj = () => import('../views/fpdj/fpdj.vue');//分配刀具
const djgqx = () => import('../views/user/djgqx.vue');//查看刀具柜拥有权限
const OrderDetail = () => import('../views/djg/order/OrderDetail.vue');//领取刀具历史记录详情
const schemaSequence = () => import('../views/schemaSequence/schemaSequence.vue');//架构数列
const productAdd = () => import('../views/productAdd/productAdd.vue'); //商品添加
const productEdit = () => import('../views/productEdit/productEdit.vue'); //商品修改
const retrieve = () => import('../views/retrieve/retrieve.vue');   //核销回收
const notReturndetail = () => import('../views/notReturndetail/notReturndetail.vue'); //未归还明细详情
const wghDetail = () => import('../views/wghDetail/wghDetail.vue'); //新刀领取未归还明细详情
const replenishmentexport = () => import('../views/djg/replenishmentexport'); //补货明细表导出

Vue.use(VueRouter)

const routes = [
  // {
  //   path:'',
  //   redirect:'../views/main.vue'
  // },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {requireAuth: false}
  },
  {
    path: '/',
    name: 'main',
    component: Main,
    meta: {requireAuth: true},
    children:[
      {path:'',redirect:'/index/index',meta: {requireAuth: true}},//默认路径
      {path:'/index/index',component:index,meta: {requireAuth: true}},//添加后台用户
      {path:'/index/auth/index',component:AuthList,meta: {requireAuth: true}},//权限列表
      {path:'/auth/AddAuth',component:AddAuth,meta: {requireAuth: true}},//添加权限
      {path:'/auth/AddZjAuth',component:AddZjAuth,name:'AddZjAuth',meta: {requireAuth: true}},//添加权限
      {path:'/auth/EditAuthName',component:EditAuthName,name:'EditAuthName',meta: {requireAuth: true}},//编辑顶级权限名称
      {path:'/index/auth/role',component:roleList,meta: {requireAuth: true}},//角色列表
      {path:'/auth/addRole',component:addRole,name:'addRole',meta: {requireAuth: true}},//添加角色
      {path:'/adminUser/adminUser',component:adminUser,meta: {requireAuth: true}},//后台用户列表
      {path:'/adminUser/AddAdminUser',component:AddAdminUser,meta: {requireAuth: true}},//添加后台用户
      {path:'/index/user/index',component:userList,name:'userList',meta: {requireAuth: true}},//用户列表
      {path:'/user/userInfo',component:userInfo,name:'userInfo',meta: {requireAuth: true}},//用户详情
      {path:'/index/com/index',component:comList,name:'comList',meta: {requireAuth: true}},//公司列表
      {path:'/index/com/shindex',component:auditCom,name:'auditCom',meta: {requireAuth: true}},//公司审核
      {path:'/index/com/ggindex',component:newList,name:'newList',meta: {requireAuth: true}},//公告列表
      {path:'/index/com/ggsp',component:auditNew,name:'auditNew',meta: {requireAuth: true}},//公告审核
      {path:'/index/sys/article',component:articleList,name:'articleList',meta: {requireAuth: true}},//文章列表
      {path:'/article/sunArticle',component:sunArticle,name:'sunArticle',meta: {requireAuth: true}},//二级文章列表
      {path:'/index/auth/version',component:version,name:'version',meta: {requireAuth: true}},//APP版本列表
      {path:'/index/device/index',component:devList,name:'devList',meta: {requireAuth: true}},//设备列表
      {path:'/device/devDetail',component:devDetail,name:'devDetail',meta: {requireAuth: true}},//设备详情
      {path:'/label/labelList',component:labelList,name:'labelList',meta: {requireAuth: true}},//标签列表
      {path:'/user/userLabel',component:userLabel,name:'userLabel',meta: {requireAuth: true}},//用户标签
      {path:'/device/wxExport',component:wxExport,name:'wxExport',meta: {requireAuth: true}},//维修单导出
      {path:'/device/gzExport',component:gzExport,name:'gzExport',meta: {requireAuth: true}},//故障率导出
      {path:'/djtype',component:djtype,name:'djtype',meta: {requireAuth: true}},//刀具柜分类管理
      {path:'/djglist',component:djglist,name:'djglist',meta: {requireAuth: true}},//刀具柜列表
      {path:'/djgyy',component:djgyy,name:'djgyy',meta: {requireAuth: true}},//刀具柜运营
      {path:'/djgbpk',component:djgbpk,name:'djgbpk',meta: {requireAuth: true}},//标品库
      {path:'/djgsp',component:djgsp,name:'djgsp',meta: {requireAuth: true}},//标品库审批
      {path:'/djgGoods',component:djgGoods,name:'djgGoods',meta: {requireAuth: true}},//刀具柜商品列表
      {path:'/djggg',component:djggg,name:'djggg',meta: {requireAuth: true}},//刀具柜广告
      {path:'/djghd',component:djghd,name:'djghd',meta: {requireAuth: true}},//刀具柜货道
      {path:'/djgorder',component:djgorder,name:'djgorder',meta: {requireAuth: true}},//刀具柜订单
      {path:'/djgjb',component:djgjb,name:'djgjb',meta: {requireAuth: true}},//刀具柜警报
      {path:'/djgrz',component:djgrz,name:'djgrz',meta: {requireAuth: true}},//刀具柜日志
      {path:'/djgver',component:djgver,name:'djgver',meta: {requireAuth: true}},//刀具柜版本管理
      {path:'/djgls',component:djgls,name:'djgls',meta: {requireAuth: true}},//刀具柜历史记录
      {path:'/fpdj',component:fpdj,name:'fpdj',meta: {requireAuth: true}},//分配刀具
      {path:'/djgqx',component:djgqx,name:'djgqx',meta: {requireAuth: true}},//查看刀具柜拥有权限
      {path:'/order/detail',component:OrderDetail,name:'OrderDetail',meta: {requireAuth: true}},//领取刀具历史记录详情
      {path:'/schema/sequence',component:schemaSequence,name:'schemaSequence',meta: {requireAuth: true}},//架构数列
      {path:'/productAdd',component:productAdd,name:'productAdd',meta: {requireAuth: true}},//商品添加
      {path:'/productEdit',component:productEdit,name:'productEdit',meta: {requireAuth: true}},//商品修改
      {path:'/retrieve',component:retrieve,name:'retrieve',meta: {requireAuth: true}},//核销回收
      {path:'/notReturndetail',component:notReturndetail,name:'notReturndetail',meta: {requireAuth: true}},//未归还明细详情
      {path:'/wghDetail',component:wghDetail,name:'wghDetail',meta: {requireAuth: true}},//新刀领取未归还明细详情
      {path:'/replenishmentexport',component:replenishmentexport,name:'replenishmentexport',meta: {requireAuth: true}},//补货明细表导出
    ]
  }
]

const router = new VueRouter({
  routes,
  mode:'hash',//改变路径展现形式
  linkActiveClass:'lulu',
})

//前置钩子（可以在这里判断登录状态）
router.beforeEach((to,from,next) => {
  console.log(to,"??");
  document.title = '捷米工业云';
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (sessionStorage.getItem('user') === 'null' || sessionStorage.getItem('user') === undefined || sessionStorage.getItem('user') === null) {
      next({
        path:'/login',
        query:{ redirect: to.fullPath }
      })
    } else {
      if (to.fullPath === "/index/sys/info") {
        alert('暂未开放此功能');
        return false;
      } else {
        next();
      }
    }
  } else {
    if (to.fullPath === "/index/sys/info") {
      alert('暂未开放此功能');
      return false;
    } else {
      next();
    }
  }
});

export default router
